<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-row justify="center" align="center">
                            <v-col cols="9" class="text-center">
                                REGISTRO DE REQUISITOS LEGALES
                            </v-col>
                            <v-col cols="2" class="text-center">
                                EI 303
                            </v-col>
                            <v-col cols="1" class="text-center">
                                <v-btn icon @click="exportarPDF" title="Imprimir / PDF">
                                    <v-icon color="red">mdi-file-pdf-box</v-icon>
                                </v-btn>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text class="pt-2">
                        <v-row justify="center" align="center">
                            <v-col cols="10" class="text-center">
                                <h6> {{ tituloaspecto }}{{ tituloalcance }} </h6>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                Fecha: {{ fecha }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="4">
                                Sitio: {{ sitio }}
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                Referencia: {{ referencia }}"
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                Evaluador: {{ evaluador }}
                            </v-col>
                            <v-col cols="12" sm="6" md="1">
                                EI 303 - Revisión: {{ revision }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-data-table dense :headers="headers" :items="listado" group-by="tipo" locale="es-ar"
                    class="elevation-1" :items-per-page="4000" hide-default-footer :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                    <template v-slot:group.header="{ items }">
                        <td :colspan="headers.length" class="text-xs-right" style="color: green;">
                            <strong>{{ items[0].tipo }}</strong>
                        </td>
                    </template>
                    <!-- <template v-slot:item.cumplimiento="{ item }">
                        <v-select dense outlined v-model="item.cumplimiento" :items="itemscumpl" item-text="nombre"
                            item-value="valor" class="font-class-name2"></v-select>
                    </template>
                    <template v-slot:item.observ="{ item }">
                        <v-textarea dense v-model="item.observ" rows="2" auto-grow outlined
                            class="font-class-name2"></v-textarea>
                    </template> -->
                </v-data-table>
                <v-card color="#FFFF99" tile>
                    <v-card-actions>
                        <div class="w-20">
                            Estado: {{ estado }}
                        </div>
                    </v-card-actions>
                </v-card>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
::v-deep .w-20 {
    width: 20% !important;
}
</style>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
// import VerInforme from "../Requisitos/Informe.vue";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        tituloalcance: "",
        tituloaspecto: "",
        tipoalcance: "",
        tipoaspecto: "",
        sitio: "",
        referencia: "",
        evaluador: "",
        fecha: "",
        revision: "",
        estado: "",
        codigoeval: "",
        loadtable: false,
        deshabilitar: false,
        itemscumpl: [{ nombre: "-", valor: "" },
        { nombre: "N/A", valor: "NA" },
        { nombre: "NO", valor: "NO" },
        { nombre: "SI", valor: "SI" },
        ],
        estados: [{ nombre: "Pendiente", valor: "P" },
        { nombre: "Cerrado", valor: "C" },
        ],
        headers: [
            { text: "Tipo", align: "center", sortable: false, value: "tipo", width: "10%" },
            { text: "Código", align: "center", sortable: false, value: "codigo", width: "10%" },
            { text: "Norma", value: "norma", sortable: false, width: "15%" },
            { text: "Organismo Emisor", value: "emisor", sortable: false, width: "15%" },
            { text: "Obligaciones", value: "oblig", sortable: false, width: "30%" },
            { text: "Cumplimiento", value: "cumplimiento", align: "center", width: "5%", sortable: false },
            { text: "Observaciones", value: "observ", align: "center", width: "20%", sortable: false },
        ],
    }),
    props: ["visible", "codeval"],

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        exportarPDF() {
            const iframe = document.createElement("iframe");
            iframe.style.position = "fixed";
            iframe.style.right = "0";
            iframe.style.bottom = "0";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(this.armarHtmlImpresion());
            doc.close();

            iframe.onload = () => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                setTimeout(() => { document.body.removeChild(iframe); }, 1000);
            };
        },

        armarHtmlImpresion() {
            let filas = "";
            this.listado.forEach((item) => {
                filas += `<tr>
                    <td>${item.codigo || ""}</td>
                    <td>${item.norma || ""}</td>
                    <td>${item.emisor || ""}</td>
                    <td>${item.oblig || ""}</td>
                    <td style="text-align:center; font-weight:700;">${item.cumplimiento || ""}</td>
                    <td>${item.observ || ""}</td>
                </tr>`;
            });

            return `<!DOCTYPE html><html><head><meta charset="utf-8"/>
                <title>EI 303 - Evaluación de Requisitos Legales</title>
                <style>
                    @page { size: A4 landscape; margin: 10mm; }
                    * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    body { font-family: Arial, sans-serif; font-size: 9px; color: #111; margin: 0; padding: 0; }
                    h1 { font-size: 14px; text-align: center; margin: 0 0 4px; }
                    h2 { font-size: 11px; text-align: center; color: #333; margin: 0 0 8px; }
                    .info { display: flex; gap: 20px; flex-wrap: wrap; font-size: 10px; margin-bottom: 8px; padding: 4px 0; border-bottom: 1px solid #ccc; }
                    .info span { }
                    .info strong { color: #333; }
                    table { width: 100%; border-collapse: collapse; font-size: 8.5px; }
                    th { background: #4CAF50; color: #fff; padding: 4px 5px; text-align: left; font-size: 8px; }
                    td { padding: 3px 5px; border-bottom: 1px solid #e0e0e0; vertical-align: top; word-break: break-word; }
                    .estado { margin-top: 8px; font-size: 11px; font-weight: 700; }
                </style>
            </head><body>
                <h1>REGISTRO DE REQUISITOS LEGALES — EI 303</h1>
                <h2>${this.tituloaspecto}${this.tituloalcance}</h2>
                <div class="info">
                    <span><strong>Fecha:</strong> ${this.fecha}</span>
                    <span><strong>Sitio:</strong> ${this.sitio}</span>
                    <span><strong>Referencia:</strong> ${this.referencia}</span>
                    <span><strong>Evaluador:</strong> ${this.evaluador}</span>
                    <span><strong>Revisión:</strong> ${this.revision}</span>
                </div>
                <table>
                    <thead><tr>
                        <th style="width:10%;">Código</th>
                        <th style="width:15%;">Norma</th>
                        <th style="width:15%;">Organismo Emisor</th>
                        <th style="width:34%;">Obligaciones</th>
                        <th style="width:6%; text-align:center;">Cumpl.</th>
                        <th style="width:20%;">Observaciones</th>
                    </tr></thead>
                    <tbody>${filas}</tbody>
                </table>
                <div class="estado">Estado: ${this.estado === "P" ? "Pendiente" : this.estado === "C" ? "Cerrado" : this.estado}</div>
            </body></html>`;
        },

        cargardatos() {
            this.loadtable = true;
            const codigo = this.codeval;
            let self = this;
            axios
                .get("/Sgi/Cargarrequisitosevaluacion?", {
                    params: {
                        codigo: codigo,
                    },
                })
                .then((response) => {
                    self.sitio = response.data.sitio;
                    self.fecha = response.data.fecha;
                    self.referencia = response.data.referencia;
                    self.evaluador = response.data.evaluador;
                    self.alcance = response.data.alcance;
                    self.aspecto = response.data.aspecto;
                    self.estado = response.data.estado;
                    self.revision = response.data.revision;
                    self.listado = response.data.cumplimiento;
                    self.loadtable = false;
                    if (response.data.aspecto == "M") {
                        self.tituloaspecto = "EVALUACIÓN DE CUMPLIMIENTO DE LA NORMATIVA MEDIOAMBIENTAL - ";
                        self.tipoaspecto = ""
                    }
                    if (response.data.aspecto == "S") {
                        self.tituloaspecto = "EVALUACIÓN DE CUMPLIMIENTO DE LA NORMATIVA SST - ";
                        self.tipoaspecto = " SST";
                    }
                    if (response.data.alcance == "M") {
                        self.tituloalcance = "MUNICIPAL";
                        self.tipoalcance = "M";
                    }
                    if (response.data.alcance == "P") {
                        self.tituloalcance = "PROVINCIAL";
                        self.tipoalcance = "P";
                    }
                    if (response.data.alcance == "N") {
                        self.tituloalcance = "NACIONAL";
                        self.tipoalcance = "N";
                    }
                    if (response.data.alcance == "C") {
                        self.tituloalcance = "CIUDAD AUTÓNOMA DE BUENOS AIRES";
                        self.tipoalcance = "CABA";
                    }
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },


        vaciarModels() {

            this.aspecto = "";
            this.estado = "A";
            this.alcance = "";
            this.fecha = "";
            this.sitio = "";
            this.evaluador = "";
            this.referencia = "";
            this.revision = "";
            this.listado = [];
            this.deshabilitar = false;
            this.$router.push({ name: "Listadorequisitosevaluacion" });
        },
    },
};
</script>